<template>
  <div class="features-modal">
    <v-dialog
      v-model="isVisible"
      max-width="780"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title
          class="features-modal__title headline"
          primary-title
        >
          {{ selectedFeature.name }}
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <div class="features-modal__row mb-0">
            <v-text-field
              v-model="newFeature"
              class="features-modal__input"
              :items="availableFeatures"
              outlined
              dense
              placeholder="Add new"
              @keyup.enter="addFeature(newFeature)"
            >
              <template #append>
                <v-icon color="blue" @click="addFeature(newFeature)">
                  mdi-plus
                </v-icon>
              </template>
            </v-text-field>
          </div>

          <div class="features-modal__row">
            <h3 class="features-modal__subtitle">
              List of <span class="text-lowercase">{{ selectedFeature.name }}</span>
            </h3>
            <div v-if="featuresList.length" class="features-modal__features-list">
              <v-chip
                v-for="(feature, index) in featuresList"
                :key="index"
                class="mr-2 mb-2"
                label
                close
                close-icon="mdi-close"
                color="orange"
                text-color="white"
                @click="removeFeature(index)"
                @click:close="removeFeature(index)"
              >
                {{ feature }}
              </v-chip>
            </div>
            <p v-else class="features-modal__empty">You have not selected any skills yet</p>
          </div>

          <div class="features-modal__row">
            <h3 class="features-modal__subtitle">
              Suggested <span class="text-lowercase">{{ selectedFeature.name }}</span>
            </h3>
            <div class="features-modal__features-list">
              <v-chip
                v-for="(feature, index) in availableFeatures"
                :key="index"
                class="mr-2 mb-2"
                label
                close
                close-icon="mdi-plus"
                color="orange-light"
                @click="addFeature(feature)"
                @click:close="addFeature(feature)"
              >
                {{ feature }}
              </v-chip>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="features-modal__actions">
          <v-btn
            class="features-modal__submit"
            color="blue"
            large
            :loading="processing"
            :min-width="255"
            @click="submit"
          >
            {{ submitName }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },

    selectedFeature: {
      type: Object,
      required: false,
    },

    featuresData: {
      type: Object,
      required: true,
    },

    processing: {
      type: Boolean,
      required: false,
      default: false,
    },

    submitName: {
      type: String,
      required: false,
      default: 'Save',
    },
  },

  data() {
    return {
      bool: true,
      newFeature: '',
      featuresList: [],
    };
  },

  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    availableFeatures() {
      const availableFeaturesList = this.isVisible
        ? this.featuresData[this.selectedFeature.slug].filter(this.checkForAvailableFeatures)
        : [];
      return availableFeaturesList;
    },
  },

  watch: {
    isVisible() {
      this.featuresList = this.isVisible ? [...this.selectedFeature.data] : [];
      this.newFeature = '';
    },
  },

  methods: {
    checkForAvailableFeatures(feature) {
      return !this.featuresList.map((item) => item.toLowerCase()).includes(feature.toLowerCase());
    },
    closeModal() {
      this.$emit('input', false);
    },

    addFeature(feature) {
      const features = feature.split(',');
      features.forEach((item) => {
        const itemString = item.trim();
        if (itemString !== '' && !this.featuresList.includes(itemString)) {
          this.featuresList.push(itemString);
          this.newFeature = '';
        }
      });
    },

    removeFeature(index) {
      this.featuresList.splice(index, 1);
    },

    submit() {
      this.$emit('submit', this.featuresList);
    },
  },
};
</script>

<style lang="scss" scoped>
.features-modal {
  &__title {
    color: $main--headers;
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }

  &__actions {
    padding: 0 24px 16px 24px;
    justify-content: flex-end;
  }

  &__submit {
    color: white;
  }

  &__row {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  &__subtitle {
    color: $main--headers;
    font-size: 18px;
    line-height: 21px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  &__input {
    max-width: 220px;
  }

  &__empty {
    margin-left: 32px;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 24px;
    margin-top: 24px;
    color: #B9BEC4;
  }
}
</style>
